import { EndpointSetting } from "@/constants/app/type"
import { FlightState } from "../type"

export const callbackRejectSearchFlight: EndpointSetting['caller'] = (
  state: FlightState,
  action: any,
  endpointName: any
) => {
  const isDomestic = !state.inputFlights.some(flight => {
    return [flight.fromAirport, flight.toAirport].some((airport) => {
      return state?.get_airports.data[airport?.code || ""]?.isDomestic === '0'
    })
  })

  state.airlines = state.airlines.map(airline => {
    if (airline.code === action.meta.arg.body.flights[0].airline) {
      return {
        ...airline,
        called: true
      }
    }
    return airline
  })
  const airlines = state.airlines.filter((airline) => airline.isDomestic === (isDomestic ? "1" : "0"))
  const progress = (airlines.filter((airline) => !!airline.called).length / airlines.length) * 100
  state.loadFlightsProgressing = progress
}